import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LoadJquery from '../helper/LoadJquery';
import VisitorTracker from '../components/VisitorTracker';
import { trackEvent } from '../api/tracker';
import { useTracks } from '../data/internshipTracks';

import ProgramTracks from '../components/Training_Components/ProgramTracks';
import InternshipApplicationForm from '../components/Training_Components/InternshipApplicationForm';
import {
  ProgrammeRoutes, WhyIntern, InternshipProcess, LifeAtStarparth, InternshipFaq,
} from '../components/Training_Components/InternshipSections';

import '../components/Training_Components/TrainingInternship.css';

const PAGE = 'training-internship';

const STATS = [
  { value: '120+', label: 'Interns trained since 2021' },
  { value: '6', label: 'Tracks across four business lines' },
  { value: '2', label: 'Interview rounds before selection' },
  { value: 'Certificate', label: 'On completion and project submission' },
];

export default function TrainingInternship() {
  const { tracks } = useTracks();
  const [selectedTrack, setSelectedTrack] = useState('');

  const scrollToApply = () => {
    trackEvent('cta_click', { label: 'hero-apply', page: PAGE });
    document.getElementById('apply')?.scrollIntoView({ behavior: 'smooth' });
  };

  const totalSeats = tracks.reduce((sum, t) => sum + (t.seats || 0), 0);

  return (
    <div className="sp-intern" data-page={PAGE}>
      <LoadJquery />
      <VisitorTracker page={PAGE} />

      {/* ------------------------------------------------------------- hero */}
      <header
        className="sp-hero"
        style={{
          backgroundImage:
            'linear-gradient(115deg, rgba(15,17,22,0.93) 0%, rgba(30,34,45,0.86) 55%, rgba(153,27,27,0.78) 100%),' +
            " url('/assets/images/banner/banner-agency.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <span className="sp-hero__badge">
                <span className="sp-hero__dot" aria-hidden="true" />
                {totalSeats > 0 ? `${totalSeats} seats open this intake` : 'Applications open'}
              </span>

              <h1 className="sp-hero__title">
                Training &amp; internships at <em>Starparth</em>
              </h1>

              <p className="sp-hero__text">
                Spend eight to twelve weeks inside the team that runs examination infrastructure,
                IT consulting and growth campaigns for clients across India. Join a live project
                directly, or start with expert-led training on your chosen course and move onto
                project work once you are ready.
              </p>

              <div className="sp-hero__actions">
                <button type="button" className="sp-btn sp-btn--primary" onClick={scrollToApply}>
                  Apply now <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                </button>
                <a
                  href="#tracks"
                  className="sp-btn sp-btn--ghost"
                  onClick={() => trackEvent('cta_click', { label: 'hero-tracks', page: PAGE })}
                >
                  See the six tracks
                </a>
              </div>

              <div className="sp-hero__stats">
                {STATS.map((stat) => (
                  <div key={stat.label}>
                    <div className="sp-hero__stat-value">{stat.value}</div>
                    <div className="sp-hero__stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* --------------------------------------------------------- sections */}
      <ProgramTracks tracks={tracks} onSelect={setSelectedTrack} />
      <ProgrammeRoutes />
      <WhyIntern />
      <InternshipProcess />
      <LifeAtStarparth />

      {/* -------------------------------------------------------- apply form */}
      <section className="sp-section sp-section--tint" id="apply">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 text-center">
              <span className="sp-eyebrow" style={{ justifyContent: 'center' }}>Apply</span>
              <h2 className="sp-heading">Send us your application</h2>
              <p className="sp-lead" style={{ margin: '0 auto 42px' }}>
                About five minutes. Have your resume ready as a PDF. We reply either way within
                seven working days.
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-9">
              <InternshipApplicationForm
                tracks={tracks}
                preselectedTrack={selectedTrack}
                key={selectedTrack}
              />
            </div>
          </div>
        </div>
      </section>

      <InternshipFaq />

      {/* --------------------------------------------------------------- cta */}
      <section className="sp-section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div
            className="sp-form-card"
            style={{ textAlign: 'center', background: '#16181d', border: 0, color: '#fff' }}
          >
            <h2 className="sp-heading" style={{ color: '#fff' }}>
              Hiring interns yourself, or looking for corporate training?
            </h2>
            <p className="sp-lead" style={{ color: 'rgba(255,255,255,0.75)', margin: '0 auto 26px' }}>
              We run customised training programmes for colleges and corporate teams across exam
              operations, IT and digital marketing.
            </p>
            <Link
              to="/contact"
              className="sp-btn sp-btn--primary"
              onClick={() => trackEvent('cta_click', { label: 'corporate-training', page: PAGE })}
            >
              Talk to our team <i className="fa-solid fa-arrow-right" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
